import BaseLine from '../../line-base';
import * as Graphic from '@src/slide/infrastructure/module/independent/graphic';
import { angleToRadian, distanceBetweenTwoPoint } from '../../../../independent/graphic';

class CurvedConnectorBase extends BaseLine {
    public getStartPos(
        crossAngle: number,
        p1: { x: number; y: number },
        p2: { x: number; y: number },
        clockWise: number,
    ) {
        const rX = Math.abs(p2.x - p1.x);
        const rY = Math.abs(p2.y - p1.y);
        if (clockWise === 1) {
            if (p2.x >= p1.x) {
                if (p2.y >= p1.y) {
                    return Graphic.polarToCartesian(p1.x, p1.y + rY, rX, rY, crossAngle);
                }
                return Graphic.polarToCartesian(p1.x + rX, p1.y, rX, rY, 270 + crossAngle);
            }
            if (p2.y >= p1.y) {
                return Graphic.polarToCartesian(p1.x - rX, p1.y, rX, rY, 90 + crossAngle);
            }
            return Graphic.polarToCartesian(p1.x, p1.y - rY, rX, rY, 180 + crossAngle);
        }
        if (p2.x >= p1.x) {
            if (p2.y >= p1.y) {
                return Graphic.polarToCartesian(p1.x + rX, p1.y, rX, rY, 270 - crossAngle);
            }
            return Graphic.polarToCartesian(p1.x, p1.y - rY, rX, rY, 180 - crossAngle);
        }
        if (p2.y >= p1.y) {
            return Graphic.polarToCartesian(p1.x, p1.y + rY, rX, rY, 360 - crossAngle);
        }
        return Graphic.polarToCartesian(p1.x - rX, p1.y, rX, rY, 90 - crossAngle);
    }

    public getEndPos(
        crossAngle: number,
        p1: { x: number; y: number },
        p2: { x: number; y: number },
        clockWise: number,
    ) {
        const rX = Math.abs(p2.x - p1.x);
        const rY = Math.abs(p2.y - p1.y);
        if (clockWise === 1) {
            if (p2.x >= p1.x) {
                if (p2.y >= p1.y) {
                    return Graphic.polarToCartesian(p1.x, p1.y + rY, rX, rY, 90 - crossAngle);
                }
                return Graphic.polarToCartesian(p1.x + rX, p1.y, rX, rY, 360 - crossAngle);
            }
            if (p2.y >= p1.y) {
                return Graphic.polarToCartesian(p1.x - rX, p1.y, rX, rY, 180 - crossAngle);
            }
            return Graphic.polarToCartesian(p1.x, p1.y - rY, rX, rY, 270 - crossAngle);
        }
        if (p2.x >= p1.x) {
            if (p2.y >= p1.y) {
                return Graphic.polarToCartesian(p1.x + rX, p1.y, rX, rY, 180 + crossAngle);
            }
            return Graphic.polarToCartesian(p1.x, p1.y - rY, rX, rY, 90 + crossAngle);
        }
        if (p2.y >= p1.y) {
            return Graphic.polarToCartesian(p1.x, p1.y + rY, rX, rY, 270 + crossAngle);
        }
        return Graphic.polarToCartesian(p1.x - rX, p1.y, rX, rY, crossAngle);
    }

    public crossAngle(length: number, w: number, h: number) {
        let ratio = Math.max(w, h) / (Math.min(w, h) > 0 ? Math.min(w, h) : 1);
        if (ratio > 8) {
            ratio = 2;
        }
        let l = 0;
        let r = 90 * ratio;
        const topPoint = {
            x: 0,
            y: h,
        };
        let mid = 0;
        while (l <= r) {
            mid = Math.floor(l + Math.floor((r - l) >> 1));
            const midPos = {
                x: w * Math.cos(angleToRadian(90 - (mid / ratio))),
                y: h * Math.sin(angleToRadian(90 - (mid / ratio))),
            };
            const distance = distanceBetweenTwoPoint(midPos, topPoint);
            if (distance > length) {
                r = mid - 1;
            } else if (distance < length) {
                l = mid + 1;
            } else {
                break;
            }
        }
        if (mid * ratio <= 1) return 0;
        return mid / ratio;
    }
}

export default CurvedConnectorBase;
